document.addEventListener("DOMContentLoaded", () => {
    initPrices();
    initGallery();
});

// ======================================
// PRICE
// ======================================

function initPrices() {
    const currencyMatch = document.cookie.match(/(?:^|; )locale=([^;]+)/);
    const currency = currencyMatch ? currencyMatch[1] : "INT";

    document.querySelectorAll<HTMLElement>(".price").forEach(el => {
        const usd = parseFloat(el.dataset.usd || "0");
        const nzd = parseFloat(el.dataset.nzd || "0");

        if (usd === 0 || nzd === 0) {
            el.textContent = "$TBD";
            markPriceLoaded(el);
            return;
        }

        el.textContent = currency === "NZ"
            ? "NZD$" + nzd.toFixed(2)
            : "USD$" + usd.toFixed(2);

        markPriceLoaded(el);
    });
}

function markPriceLoaded(el: HTMLElement) {
    el.classList.remove("price-loading");
    el.removeAttribute("aria-busy");
}

function initGallery() {
    const tabs = document.querySelectorAll<HTMLButtonElement>(".gallery-tab");
    const panels = document.querySelectorAll<HTMLElement>(".gallery-panel");
    const heroPanel = document.getElementById("hero-panel");

    if (!tabs.length) return;

    function activateTab(index: number) {
        const isMain = index === 0;
        const left = document.getElementById("product-left");

        left?.classList.toggle("gallery-mode", !isMain);

        // Hero visibility
        if (heroPanel) {
            heroPanel.classList.toggle("hidden", !isMain);
        }

        // Tabs styling (keep yours)
        tabs.forEach((t, i) => {
            const active = i === index;
            t.classList.toggle("text-[var(--kotare-green)]", active);
            t.classList.toggle("border-[var(--kotare-green)]", active);
            t.classList.toggle("text-gray-500", !active);
            t.classList.toggle("border-transparent", !active);
        });

        // Panels
        panels.forEach((p, i) => {
            if (i === index) {
                p.classList.remove("hidden");
                p.style.opacity = "0";
                p.style.transform = "translateY(6px)";
                p.style.transition = "opacity 0.2s ease, transform 0.2s ease";

                requestAnimationFrame(() => {
                    p.style.opacity = "1";
                    p.style.transform = "translateY(0)";
                });
            } else {
                p.classList.add("hidden");
            }
        });
    }

    tabs.forEach((tab, i) => {
        tab.addEventListener("click", () => activateTab(i));
    });

    // Activate first tab on load
    activateTab(0);
}
